import React, { Suspense, lazy, useRef, useState } from "react";
import "../styles/HomePage/HomePage.css";
import { useMediaQuery } from "react-responsive";
import ServiceCount from "./ServiceCount";
import ContactusForm from "./ContactusForm";
import BrowseVideos from "./BrowseVideos/BrowseVideos";
import graphImage from '../images/graphImage.png';
import StartupPotential from "./StartupPotential/StartupPotential";
import Vision from "./Vision/Vision";
import FeaturedBlog from "./Blogs/FeaturedBlog";
import Message from "../UsefulCompoments/Message";

const AnimatedComponent = lazy(() => import('./AnimatedComponents/AnimatedComponent'));
const GraphMobileComponent = lazy(() => import('./AnimatedComponents/GraphMobileComponent'));

const stagesData = [
  {
    stageId: "idea-stage",
    title: "Idea Stage",
    shortInfo: "The idea stage of a startup is when founders define a problem, brainstorm solutions, and outline a basic vision for their product or service. It's focused on validating the concept and identifying potential market opportunities.",
    videos : [
      { 
        thumbnailUrl: "https://img.youtube.com/vi/7o-VYbCiBCI/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/7o-VYbCiBCI?si=noMRkvw_Mfqkdcl9" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/-j18OmFNhe8/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/KjDzpfS6y3w" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/7o-VYbCiBCI/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/KjDzpfS6y3whttps://youtube.com/video3" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/JErZACCwxqQ/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/JErZACCwxqQ?si=iKTpkGKtrPWcQb_5" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/07dW35Wgf9g/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/07dW35Wgf9g?si=tXd5uW64VYu8BtpP" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/EUj9UQI0x-M/hqdefault.jpg",  
        videoUrl: "https://www.youtube.com/embed/EUj9UQI0x-M?si=as-6pIYo1ZbyO761" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/aDRli55IMSc/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/aDRli55IMSc?si=fhslEWLU96Evx0RN" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/znGlydyKuPo/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/znGlydyKuPo?si=qoyumMaJ3UZlJ16c" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/fRwS1KNA5Oo/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/fRwS1KNA5Oo?si=H2lVCpOmJV-RAkRw" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/Q5j3nxuJ6Zk/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/Q5j3nxuJ6Zk?si=t3VHfgCJHpSZYDfU" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/akTGvxIxL6k/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/akTGvxIxL6k?si=ONZpMFphXZIBFieG" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/laphEGGQvVg/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/laphEGGQvVg?si=FScS4Kgbpe69AUhd" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/bgH4kUK4l54/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/bgH4kUK4l54?si=Agk1iL_lMBnLyktR" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/atDc4uHyx-A/hqdefault.jpg",  
        videoUrl: "https://www.youtube.com/embed/atDc4uHyx-A?si=bLmsFm7cvA_mo5Dv" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/J4jRiEevEsU/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/J4jRiEevEsU?si=F-36klGWYVtjpTnH" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/bPOMUzhUp5g/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/bPOMUzhUp5g?si=8ND2UmtheX1bQAOt" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/WdHofTCNJlo/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/WdHofTCNJlo?si=2UH0TblA_esBi6SN" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/6-D0rJJv11Y/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/6-D0rJJv11Y?si=6wyiEDfhQ0kiG9pb" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/beD5TB8MyLw/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/beD5TB8MyLw?si=iCZvF0mciuoJR3Wb" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/saSuovTdS5E/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/saSuovTdS5E?si=VIbhIav9c0Mw-GNP" 
      }
    ]
    
  },
  {
    stageId: "valley-stage",
    title: "Valley of Death",
    shortInfo: " The Death Valley stage of a startup is a critical period where cash flow is tight, and the business struggles to gain traction or secure funding. It's a make-or-break phase requiring resilience, resourcefulness, and clear strategic direction to survive.",
    videos: [
      { 
        thumbnailUrl: "https://img.youtube.com/vi/0j9W_2FP19o/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/0j9W_2FP19o?si=E7PRiNGxpv6YDR-b" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/iQVsiJ1aXm8/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/iQVsiJ1aXm8?si=TPE9sbSyIIIxosrs" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/uUWDToQwgss/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/uUWDToQwgss?si=v0odWXiNYfKsg615" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/S1zIPDdPMpU/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/S1zIPDdPMpU?si=WPnwjOfAiJDEiuzn" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/fSTvSVTU8uc/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/fSTvSVTU8uc?si=wKvZO3bgQRh85wv5" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/td0y0Yk8JDY/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/td0y0Yk8JDY?si=g5eice_EfY7i_wGq" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/I-d49X5VoMI/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/I-d49X5VoMI?si=yeMldWK-6Kfxsj5V" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/ct0zmPMkzcQ/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/ct0zmPMkzcQ?si=UB1m9CUjXdFH7019" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/Rl15Q6BPO1s/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/Rl15Q6BPO1s?si=jV27IZj7RkS-EU72" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/cBIVa7bNvYI/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/cBIVa7bNvYI?si=_ZqNSzdNSYuEbOCn"
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/_vxldGtLEBE/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/_vxldGtLEBE?si=U051i-DBuBhmMKQ-" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/JUZ2XY1d4Bc/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/JUZ2XY1d4Bc?si=maBzY140DcuAtXWZ" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/wQdobPu4vlc/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/wQdobPu4vlc?si=QhYXx8CR_OJIJTe5" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/UZ924nHUObM/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/UZ924nHUObM?si=0A3vKnthkPl-8X_o" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/KADFvH9M46k/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/KADFvH9M46k?si=I7GLN7y5wbDsbQXD" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/ay_MNRGLa1c/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/ay_MNRGLa1c?si=s2Lg-71vjWeAkTvH" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/JrtR4bQRdhw/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/JrtR4bQRdhw?si=mSZa83yCwcWJbkQ5" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/SAZqAk-sNJc/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/SAZqAk-sNJc?si=95kWabNnIU-MjKQw" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/VDD0zH_5y_I/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/VDD0zH_5y_I?si=S4IigsuLCvQAK0u1" 
      }
    ]    
    
  },
  {
    stageId: "growth-stage",
    title: "Growth Stage",
    shortInfo: "The growth stage of a startup is when the business scales operations, increases market share, and generates consistent revenue. Focus shifts to optimizing processes, expanding teams, and maintaining customer satisfaction while managing rapid development.",
    videos : [
      { 
        thumbnailUrl: "https://img.youtube.com/vi/KjDzpfS6y3w/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/KjDzpfS6y3w?si=CI5Lr7tFla8AD6CK" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/C91SGEJkWgc/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/C91SGEJkWgc?si=86jgeaMAKNGfqzJP" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/O0u6L2p3Vew/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/O0u6L2p3Vew?si=WDj3g3Q7RcRu5cpR" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/-YAmQSNmskc/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/-YAmQSNmskc?si=ht6BschXEAKfb3Wk" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/z54Zjk1cHhY/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/z54Zjk1cHhY?si=YK2dUqmUcflGxK2C" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/-Yt0WKBATK4/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/-Yt0WKBATK4?si=iwHzN61qNILek9Rx" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/s-7qZmc6upo/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/s-7qZmc6upo?si=j9sqCMgGl6xvEFeZ" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/9Boj1Pvk7hU/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/9Boj1Pvk7hU?si=JFEAkB_RaIHtq8Js" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/r9SEJ5LxQEo/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/r9SEJ5LxQEo?si=v73fcZTKY69dQm0R" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/2nrlpTDQhH4/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/2nrlpTDQhH4?si=r_cDzBGGqJVQ2MIt" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/7qFH5tWYfN0/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/7qFH5tWYfN0?si=AumhdLozyWHQyD7f" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/7W0VxTZBdos/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/7W0VxTZBdos?si=sSt-CHtp6DaxyrAE" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/qJ_H9kMYN1k/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/qJ_H9kMYN1k?si=m2x7IErbG4evrUkI" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/LR4BVqQ3p9U/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/LR4BVqQ3p9U?si=OwTAqrbDF412SIVg" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/R0VyWA9fpOM/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/R0VyWA9fpOM?si=H1mXs2hdcW7HKCCE" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/dG14J3hyvPI/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/dG14J3hyvPI?si=VarHLFAuLTTstp7s" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/2iACqSxPVkI/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/2iACqSxPVkI?si=ry0my4i5_uwcxVTg" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/qP30sGXYls4/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/qP30sGXYls4?si=i0oZcacf7-jYn0Wx" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/Y2q076z7ZUs/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/Y2q076z7ZUs?si=HIlb9_ZUt1Hir1LC" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/MvTE5kGJVKk/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/MvTE5kGJVKk?si=Z7Br1uSanhbjM996" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/bq9tQ8lpJTA/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/bq9tQ8lpJTA?si=ObACqrlaG-VfrbO6" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/FmZjSlUbsh4/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/FmZjSlUbsh4?si=WEjsxJwJmTEiKFk9" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/4soB9KIF4gI/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/4soB9KIF4gI?si=LtSPrr6zPdMfCOEX" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/DFeWLCt91sI/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/DFeWLCt91sI?si=lAPVDg_G_B1Yj9Jm" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/uq9wPr5LF5I/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/uq9wPr5LF5I?si=OkY8-lrCR0rgCY1N" 
      },
      { 
        thumbnailUrl: "https://img.youtube.com/vi/YB_bA2OjKno/hqdefault.jpg", 
        videoUrl: "https://www.youtube.com/embed/YB_bA2OjKno?si=7maq22OD_gvM0ZCY" 
      }
    ]    
    
  }
];

function HomePage() {
  const animatedRef = useRef(null); // Create a ref
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const [isSuccess, setIsSuccess] = useState(false)
  const [successData, setSuccessData] = useState({})
  const [showForm, setShowForm] = useState(false);
  const handleFreeEvaluationClick = () => {
    console.log("Show Free Evaluation Form");
    setShowForm(!showForm);
  };
  // Function to trigger animations in AnimatedComponent
  const handleStageClassification = (stage) => {
    if (animatedRef.current) {
      animatedRef.current.triggerAnimation(stage); // Call function inside AnimatedComponent
    }
  };

  function handleSetSucess(show,data){
    console.log("handleSetSucess called", data);
    console.log("handleSetSucess called", show);
    setShowForm(false);
    setIsSuccess(show);
    setSuccessData({
      type: data?.type || "error",
      message: data?.message || "Something went wrong.",
    })
  }
  return ( 
    <Suspense fallback={<div className="loading-spinner">Loading...</div>}>
    <>
      <div className="screen-design">
        <section >
        {isDesktop ? (
        <AnimatedComponent /> // Desktop view
         ) : (
         <GraphMobileComponent graphImage={graphImage} stages={stagesData} /> // Mobile view
        )}
        </section>
       
        {/* <section>
          <ContactusForm onStageClassification={handleStageClassification} />
        </section> */}
      </div>
      <section style={{textAlign:"center"}}>
        <BrowseVideos />
      </section>
      <section style={{width:"90%", margin:"auto"}}>
        <ServiceCount />
      </section>
      {/* <section style={{textAlign:"center"}}>
        <FeaturedBlog />
      </section> */}
      <section style={{textAlign:"center"}}>
        <StartupPotential handleSetSucess={handleSetSucess} handleFreeEvaluationClick={handleFreeEvaluationClick} showForm={showForm} setShowForm={setShowForm} />
        {isSuccess && <Message handleClick={handleSetSucess} data={successData} />}
      </section>
      <section style={{textAlign:"center"}}>
        <Vision />
      </section>
    </>
    </Suspense>
  );
}

export default HomePage;
